import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

// Set REACT_APP_BYPASS_AUTH=true in .env ONLY for local development
// NEVER set to true in production!
const BYPASS_AUTH = process.env.REACT_APP_BYPASS_AUTH === 'true';

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  // Bypass authentication check if BYPASS_AUTH is true (development only)
  if (!BYPASS_AUTH && !isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

